import { usePersistedQueryParams } from '@plato/app-shared/hooks/use-persisted-query-params';
import {
    enumParam,
    generateQueryParamsString,
    objectParam,
    queryParamsConfig,
    requiredParam,
    stringArrayParam,
    stringParam,
    transientParam,
} from '@plato/ui-legacy/lib/query-params';
import { TaskSortBy, type CrmTaskFilterOptions } from '../../../server/dto/crm-task-dto.ts';
import { SortOrder } from '../../../server/types/list-view-types.ts';

export type TaskListFilters = Required<
    Pick<
        CrmTaskFilterOptions,
        | 'customerIds'
        | 'salesOrderIds'
        | 'salesQuoteIds'
        | 'assignedByIds'
        | 'assignedToIds'
        | 'searchText'
        | 'sortingFilter'
    >
>;

const taskListFiltersConfig = queryParamsConfig<TaskListFilters>({
    customerIds: stringArrayParam(),
    salesOrderIds: stringArrayParam(),
    salesQuoteIds: stringArrayParam(),
    assignedByIds: stringArrayParam(),
    assignedToIds: stringArrayParam(),
    searchText: transientParam(stringParam()),
    sortingFilter: objectParam({
        field: requiredParam(enumParam(TaskSortBy)),
        direction: requiredParam(enumParam(SortOrder)),
    }),
});

const defaultFilters: TaskListFilters = {
    customerIds: [],
    salesOrderIds: [],
    salesQuoteIds: [],
    assignedByIds: [],
    assignedToIds: [],
    searchText: '',
    sortingFilter: {
        field: TaskSortBy.DUE_DATE,
        direction: SortOrder.ASC,
    },
};

export function buildTaskListUrl(filters: Partial<TaskListFilters>): string {
    return `/tasks?${generateQueryParamsString(taskListFiltersConfig, filters)}`;
}

export function useTaskListFilters() {
    const [appliedFilters, setAppliedFilters] = usePersistedQueryParams(
        taskListFiltersConfig,
        defaultFilters,
        'tasks',
    );

    return {
        appliedFilters,
        setAppliedFilters,
        defaultFilters,
    };
}
